<script>
    import { fade } from 'svelte/transition';
    import UserStore from '../stores/user';
    import fetchData from '../api.js';
    import {link, push} from 'svelte-spa-router'
    import { locale, _ } from 'svelte-i18n';
    import { onMount , createEventDispatcher} from 'svelte';
    import { allowed_stores , storeNames , apply_store_list } from '../variables';
    export let params = {};
    export let note = {};
    export let index = 0;

    let dispatch = createEventDispatcher();

    let store = params.store_id;
    let barcode = false;
    let formattedDate;
    let status_desc;
    let status;

    if ( note.SourceCard == store || note.DestinationCard == store ) {

        const year = note.CreateDate.slice(0, 4);
        const month = note.CreateDate.slice(4, 6);
        const day = note.CreateDate.slice(6, 8);

        formattedDate = `${day}/${month}/${year}`;

        //console.log('log note',note)
        if (typeof note.Status === 'string' && isNaN(parseInt(note.Status))) {
            status = note.Status.trim();
        } else {
            status = note.Status
        }
        status_desc = '';

        if (status==6 || status=="6") {
            status_desc = 'הספקה חלקית';
        } else if (status==5 || status=="5") {
            status_desc = 'אושרה';
        } else if (status==3 || status=="3") {
            status_desc = 'סגורה';
        }
        
        barcode = note.DeliveryNoteNo;        

        if (apply_store_list.indexOf(note.SourceCard)!==-1) {
            barcode = (`${note.SourceCard}`).padStart(3,0) + (`${note.DeliveryNoteNo}`).padStart(6,0);            
        } 

        
        
    }

    onMount(async() => {

        JsBarcode("#note-bacrode"+barcode+"", barcode, {
            width: 2, // Set the width of the barcode lines
            height: 50, // Set the height of the barcode
        });

    });

</script>
<style>
    .note {
        display: flex;;
        padding: 20px 20px;
        border-bottom:1px solid #f1f1f1;
        font-size: 15px;;
        justify-content:space-between;
        align-items: center;;
    }
    
    .note > span,
    .note > a {
        display: flex;
        justify-content:flex-start;
        align-items: center;
    }
    .note > span,
    .note > a {
        flex-direction: column;
        align-items: normal;
    }
    .note > span > span > i ,
    .note > a > span > i {
        margin: 0 5px;;
        color: #c1c1c1;
    }

    .note .checked {
        background-color: #FFCF01;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        align-items: center;
        display: flex;
        justify-content: center;
        display: none;;
    }
    .note.scanned .checked {
        display: flex;;
    }
    .note .checked i{
        font-size: 20px;;
    }

    
</style>
{#if barcode}
<div class:scanned={note.scanned} data-index="{index}" id="note{barcode}" class="note" data-status="{status}" data-note="{note.DeliveryNoteNo}" data-store="{note.SourceCard}" data-origin="{note.CreationStoreNo}" data-destination="{note.DestinationCard}">
    <a href="/store/{store}/note/{note.DeliveryNoteNo}" use:link>
        <span><i class="fas fa-file"></i> מספר תעודה: {barcode}</span>
        <span><i class="fas fa-building"></i> מעבר מחסנים: {note.SourceName} <i class="fas fa-arrow-left"></i> {note.DestinatioName}</span>
        <span><i class="far fa-calendar"></i> תאריך התעודה: {formattedDate} </span>
        <span><i class="fas fa-shopping-cart"></i> מספר פריטים בתעודה: {note.TotalItems} </span>
        <span><i class="fas fa-user"></i> יוצר התעודה: {note.WorkerCreatingDoc}</span>
        {#if status_desc}<span><span class="note-status note-status{status}">{status_desc}</span></span>{/if}
        <!-- <span><svg id="note-bacrode{barcode}"></svg></span> -->
    </a>
    <span class="checked" on:click={() => dispatch('removeSelectedNote', { note : note.DeliveryNoteNo , index: index} ) }>
        <i class="fa-solid fa-check"></i>
    </span>
</div>
{/if}